import { render, staticRenderFns } from "./PricePlanProvider.vue?vue&type=template&id=381a95f7"
import script from "./PricePlanProvider.vue?vue&type=script&lang=ts"
export * from "./PricePlanProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381a95f7')) {
      api.createRecord('381a95f7', component.options)
    } else {
      api.reload('381a95f7', component.options)
    }
    module.hot.accept("./PricePlanProvider.vue?vue&type=template&id=381a95f7", function () {
      api.rerender('381a95f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/prices/PricePlanProvider.vue"
export default component.exports